var render = function render(){var _vm=this,_c=_vm._self._c;return _c('b-form-group',[_c('label',{staticClass:"mb-1 text-lg d-flex align-items-center"},[_vm._v(" Trường đại học ")]),_c('b-input',{attrs:{"type":"text","placeholder":"Nhập trường đại học..."},model:{value:(_vm.entry.university),callback:function ($$v) {_vm.$set(_vm.entry, "university", $$v)},expression:"entry.university"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }